<template>
  <div class="by-container">
    <header class="by-container clearFix">
      <div class="by-content clearFix">
        <div class="brand-title fl">
          <a href="/" class="img-wrapper">
            <img src="/static/logo.png" alt />
          </a>
        </div>
        <ul class="nav-container fl">
          <router-link tag="li" class="nav-item fl" :active-class="$route.name === 'index'?'active':''" :to="{name:'index'}">首页</router-link>
          <router-link tag="li" class="nav-item fl" active-class="active" :to="{name:'channellines'}">查询线路</router-link>
          <router-link tag="li" class="nav-item fl" active-class="active" :to="{name:'branches'}">查询网点</router-link>
          <router-link tag="li" class="nav-item fl" active-class="active" :to="{name:'enterpriselist'}">企业黄页</router-link>
        </ul>
        <div class="fr" v-if="userinfo.Id === ''">
          <router-link tag="a" class="btn btn-login" :to="{name:'login'}">登录</router-link>
          <router-link tag="a" class="btn btn-register" :to="{name:'register'}">注册</router-link>
        </div>
        <div class="fr" v-else style="color:#ffffff;">
          欢迎
          {{userinfo.nickName}}[{{userinfo.name}}]
          ,<router-link :to="{name:'etms'}" tag="a" class="btn btn-login">进入管理中心</router-link>
        </div>
      </div>
    </header>
    <router-view></router-view>
    <div class="clear"></div>
    <div class="by-container clearFix">
      <footer>
        <div class="by-footer">
          <div class="logo fl">
            <img src="/static/logo-small.png" alt="" />
          </div>
          <div class="link-content fl">
            <p>逸天科技
              <a href="https://www.17track.net" target="_blank">17track全球物流跟踪</a>
            </p>
            <p>
              <a href="https://www.logistics.dhl" target="_blank">DHL</a>
              <a href="https://www.ups.com" target="_blank">UPS</a>
              <a href="https://www.ups.com" target="_blank">TNT</a>
              <a href="https://www.fedex.com" target="_blank">Fedex</a>
              <a href="http://www.ems.com.cn" target="_blank">EMS</a>
              <a href="http://www.sf-express.com" target="_blank">顺丰</a>
              <a href="http://www.chinapost.com.cn" target="_blank">中国邮政</a>
            </p>
            <p>©广州逸天信息科技有限公司版权所有 工信部备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18113183号</a> 公安部备案号：粤公网安备44011102484493号</p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userinfo: {
        Id: '',
        EnterpriseId: '',
        LoginName: '',
        LoginHostAddress: '',
        LoginToken: '',
        LoginPassword: '',
        Name: '',
        NickName: ''
      },
    }
  },
  watch: {
    $route (to, form, next) {
      this.loadUserInfo()
    }
  },
  mounted () {
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo () {
      var user = this.$cookies.get('userinfo')
      if (user !== null && user !== undefined) {
        this.userinfo = user
      }
    }
  }
}
</script>

<style>
@import "../../css/home/home.css";
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue